import React, { useReducer, createContext, useContext, useState } from 'react';
import { Box } from "@mui/system";
import Navbar from "./components/Navbar";
import { Button, Stack } from '@mui/material';
import CustomCard from '../../components/CustomCard';
import featureData from '../../data/feature-data';
import installationData from '../../data/installation-data';
import HorizonListItem from './components/HorizonListItem';
import { Add } from '@mui/icons-material';
import InvoiceTable from '../invoice/components/InvoiceTable';

const initialState = {
  equipments: [{ id: 0, title: "", description: "", unit: "", quantity: "", amount: "" }],
  options: [{ id: 0, title: "", description: "", unit: "", quantity: "", amount: "" }],
  oneTime: [{ id: 0, title: "", description: "", unit: "", quantity: "", amount: "" }],
  features: featureData,
  installs: installationData,
};

const actions = {
  CHANGE_EQUIPMENT: "CHANGE_EQUIPMENT",
  ADD_EQUIPMENT: "ADD_EQUIPMENT",
  REMOVE_EQUIPMENT: "REMOVE_EQUIPMENT",
  CHANGE_OPTION: "CHANGE_OPTION",
  ADD_OPTION: "ADD_OPTION",
  REMOVE_OPTION: "REMOVE_OPTION",
  CHANGE_ONE_TIME: "CHANGE_ONE_TIME",
  ADD_ONE_TIME: "ADD_ONE_TIME",
  REMOVE_ONE_TIME: "REMOVE_ONE_TIME",
  CHANGE_FEATURE: "CHANGE_FEATURE",
  CHANGE_INSTALL: "CHANGE_INSTALL",
};

const reducer = (state, action) => {
  switch (action.type) {
    case actions.CHANGE_EQUIPMENT: {
      const u = state.equipments.map((i) => i.id === action.id ? action.status : i);
      return { ...state, equipments: u };
    } case actions.ADD_EQUIPMENT: {
      const u = [
        ...state.equipments, { id: action.id, title: "", description: "", unit: "", quantity: "", amount: "" },
      ];
      return { ...state, equipments: u };
    } case actions.REMOVE_EQUIPMENT: {
      const u = state.equipments.filter((i) => i.id !== action.id);
      return { ...state, equipments: u };
    } case actions.CHANGE_OPTION: {
      const u = state.options.map((i) => i.id === action.id ? action.status : i);
      return { ...state, options: u };
    } case actions.ADD_OPTION: {
      const u = [
        ...state.options, { id: action.id, title: "", description: "", unit: "", quantity: "", amount: "" },
      ];
      return { ...state, options: u };
    } case actions.REMOVE_OPTION: {
      const u = state.options.filter((i) => i.id !== action.id);
      return { ...state, options: u };
    } case actions.CHANGE_ONE_TIME: {
      const u = state.oneTime.map((i) => i.id === action.id ? action.status : i);
      return { ...state, oneTime: u };
    } case actions.ADD_ONE_TIME: {
      const u = [
        ...state.oneTime, { id: action.id, title: "", description: "", unit: "", quantity: "", amount: "" },
      ];
      return { ...state, oneTime: u };
    } case actions.REMOVE_ONE_TIME: {
      const u = state.oneTime.filter((i) => i.id !== action.id);
      return { ...state, oneTime: u };
    } case actions.CHANGE_FEATURE: {
      const u = state.features.map((i) => i.id === action.id ? { ...i, status: action.status } : i);
      return { ...state, features: u };
    } case actions.CHANGE_INSTALL: {
      const u = state.installs.map((i) => i.id === action.id ? { ...i, status: action.status } : i);
      return { ...state, installs: u };
    }
    default:
      return state;
  }
};

export const HomeContext = createContext();

export const HomeProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [eqpCount, setEqpCount] = useState(1);
  const [optCount, setOptCount] = useState(1);
  const [oneCount, setOneCount] = useState(1);
  const value = {
    equipments: state.equipments,
    options: state.options,
    oneTime: state.oneTime,
    features: state.features,
    installs: state.installs,
    onChangeEquipment: (id, status) => {
      dispatch({ type: actions.CHANGE_EQUIPMENT, id: id, status: status });
    }, onAddEquipment: () => {
      dispatch({ type: actions.ADD_EQUIPMENT, id: eqpCount });
      setEqpCount(eqpCount + 1);
    }, onRemoveEquipment: (id) => {
      dispatch({ type: actions.REMOVE_EQUIPMENT, id: id });
    }, onChangeOption: (id, status) => {
      dispatch({ type: actions.CHANGE_OPTION, id: id, status: status });
    }, onAddOption: () => {
      dispatch({ type: actions.ADD_OPTION, id: optCount });
      setOptCount(optCount + 1);
    }, onRemoveOption: (id) => {
      dispatch({ type: actions.REMOVE_OPTION, id: id });
    }, onChangeOneTime: (id, status) => {
      dispatch({ type: actions.CHANGE_ONE_TIME, id: id, status: status });
    }, onAddOneTime: () => {
      dispatch({ type: actions.ADD_ONE_TIME, id: oneCount });
      setOneCount(oneCount + 1);
    }, onRemoveOneTime: (id) => {
      dispatch({ type: actions.REMOVE_ONE_TIME, id: id });
    }, onChangeFeature: (id, status) => {
      dispatch({ type: actions.CHANGE_FEATURE, id: id, status: status });
    }, onChangeInstall: (id, status) => {
      dispatch({ type: actions.CHANGE_INSTALL, id: id, status: status });
    },
  };
  return (
    <HomeContext.Provider value={value}>
      {children}
    </HomeContext.Provider>
  );
};

const Home = () => {
  const {
    equipments, onChangeEquipment, onAddEquipment, onRemoveEquipment,
    options, onChangeOption, onAddOption, onRemoveOption,
    oneTime, onChangeOneTime, onAddOneTime, onRemoveOneTime,
    features, installs, onChangeFeature, onChangeInstall,
  } = useContext(HomeContext);

  const invoiceSection = [
    { isHeader: true, title: "Features Included", subtitle: "Value" }, ...features.map((i) => ({ ...i, onChange: onChangeFeature })),
    { isHeader: true, title: "Installation and Peripherals", subtitle: "Value" }, ...installs.map((i) => ({ ...i, onChange: onChangeInstall, canShowNa: true })),
  ];

  return (
    <Box sx={{ backgroundColor: "ghostwhite" }}>
      <Navbar />
      <Box margin={"16px"}>
        <Stack direction="column" spacing={"16px"}>
          <CustomCard title="Equipments">
            <Stack direction="column" spacing={1}>
              {equipments.map((e) =>
                <div key={e.id}>
                  <HorizonListItem id={e.id} value={e} onChange={onChangeEquipment} onRemove={onRemoveEquipment} />
                </div>
              )}
              <Button variant="outlined" size="small" sx={{ maxWidth: 100 }} endIcon={<Add />} onClick={onAddEquipment}>ADD</Button>
            </Stack>
          </CustomCard>
          <CustomCard title="Recurring Charges">
            <Stack direction="column" spacing={1}>
              {options.map((e) =>
                <div key={e.id}>
                  <HorizonListItem id={e.id} value={e} onChange={onChangeOption} onRemove={onRemoveOption} />
                </div>
              )}
              <Button variant="outlined" size="small" sx={{ maxWidth: 100 }} endIcon={<Add />} onClick={onAddOption}>ADD</Button>
            </Stack>
          </CustomCard>
          <CustomCard title="One Time Charges">
            <Stack direction="column" spacing={1}>
              {oneTime.map((e) =>
                <div key={e.id}>
                  <HorizonListItem id={e.id} value={e} onChange={onChangeOneTime} onRemove={onRemoveOneTime} />
                </div>
              )}
              <Button variant="outlined" size="small" sx={{ maxWidth: 100 }} endIcon={<Add />} onClick={onAddOneTime}>ADD</Button>
            </Stack>
          </CustomCard>
          <InvoiceTable section={invoiceSection} isChangeable={true} />
          {/* <Grid container spacing={1} columns={{ xs: 2, sm: 4 }}>
            <Grid item xs={2} sm={2}>
              <Stack direction="column" spacing={1}>
                <CustomCard
                  title="Optional Extras"
                  content={
                    <Stack direction="column" spacing={1}>
                      {options.map((e) =>
                        <div key={e.id}>
                          <CustomTile title={e.title} subtitle={e.subtitle}>
                            <CustomToggle id={e.id} value={e.status} onChange={onChangeOption} />
                          </CustomTile>
                        </div>
                      )}
                    </Stack>
                  }
                />
                <CustomCard
                  title="Installation and Peripherals"
                  content={
                    <Stack direction="column" spacing={1}>
                      {installs.map((e) =>
                        <div key={e.id}>
                          <CustomTile title={e.title} subtitle={e.subtitle}>
                            <CustomToggle id={e.id} value={e.status} onChange={onChangeInstall} canShowNa={true} />
                          </CustomTile>
                        </div>
                      )}
                    </Stack>
                  }
                />
              </Stack>
            </Grid>
            <Grid item xs={2} sm={2}>
              <CustomCard
                title="Features"
                content={
                  <Stack direction="column" spacing={1}>
                    {features.map((e) =>
                      <div key={e.id}>
                        <CustomTile title={e.title} subtitle={e.subtitle}>
                          <CustomToggle id={e.id} value={e.status} onChange={onChangeFeature} />
                        </CustomTile>
                      </div>
                    )}
                  </Stack>
                }
              />
            </Grid>
          </Grid> */}
        </Stack>
      </Box>
    </Box>
  )
}

export default Home